export enum UniqeCodeTypeEnum {
  UPLOAD_CODE = 'UPLOAD_CODE',
  GENERATE_CODE = 'GENERATE_CODE',
}
